import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="sp-page">
      <section className="sp-hero sp-404">
        <div className="sp-container">
          <p className="sp-eyebrow">Error 404</p>
          <h1 className="sp-h1">
            Page <span style={{ fontStyle: "italic", color: "#93c5fd" }}>not found</span>
          </h1>
          <p className="sp-lead" style={{ margin: "0 auto 2.5rem" }}>
            The page you are looking for does not exist or has moved. Try one of
            these instead.
          </p>
          <div className="sp-404-actions">
            <Link to="/" className="sp-btn-white-sq">
              Back to home <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/services" className="sp-btn-outline-sq">
              Our services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
